export const isUUID = (str) => {
	// Regular expression to check if string is a valid UUID
	const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

	return regexExp.test(str);
}

export const getIndexDomainName = (domain_name) =>  {
    const hostnameArray = domain_name.split('.')
    const numberOfSubdomains = hostnameArray.length - 2
    return hostnameArray.length === 2 ? domain_name : hostnameArray.slice(numberOfSubdomains).join('.')
}